import src from "IMAGE";
export default { src, width: 378, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADbVcfxD2Xv/PNh2/zjXc/8+2Hf/P9h4/z7YeP8u02v8ADvWdfxI2n7/Pth4/zzYdv8/2Hj/Q9l7/0baff8y1G78KYEoj0boTicAAAAASUVORK5CYII="};
